module.exports = __webpack_public_path__ + "img/plane_track_1.40aab421.svg";